/**
 * Checks if window is defined
 *
 * @returns {boolean} true if window is defined, false otherwise
 */
var isWindowDefined = typeof window !== 'undefined';
export default isWindowDefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/isWindowDefined.js
// module id = 607
// module chunks = 11